import { Suspense } from 'react';
import { compose } from 'recompose';
import { withSnowPlow as withSnowplow } from '~/components/Snowplow';
import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';

import globalEnv from '~/config/env';
import { withTranslationsInternal } from '~/components/Intl';
import { withRelay } from '~/components/Relay';
import { withRedux } from '~/components/Redux';
import { useVisibilityForLegacyUrl } from '~/components/LegacyAppRouting/components/Learner';
import { APP_NAME, DYNAMIC_REMOTES } from '~/config/app.constants';
import { useUserAuth } from '~/components/Auth';

import Loader from './Loader';

const LearnerHeader = () => {
  const isVisible = useVisibilityForLegacyUrl(globalEnv.LEGACY_WHITELISTED_HEADER_ROUTES);
  const { company } = useUserAuth();
  const isHeaderHidden = company?.companySettings?.isExperienceCloudEnabled;
  if (isVisible) {
    return (
      <Suspense fallback={<span />}>
        <LoadRemote
          remote={DYNAMIC_REMOTES.LEARNER_HEADER}
          loader={isHeaderHidden ? <span /> : <Loader />}
          lazy={false}
          onIdleEnabled={false}
        />
      </Suspense>
    );
  }
  return null;
};

export default compose(
  withTranslationsInternal({
    appName: DYNAMIC_REMOTES.LEARNER_HEADER.appName,
    loader: <Loader />,
  }),
  withSnowplow({
    collectorUrl: globalEnv.RXP_SVC_SNOWPLOW_INGRESS,
    namespace: APP_NAME,
  }),
  withRedux(),
  withRelay({
    enableSubscription: false,
    graphqlEndpoint: globalEnv.READINESS_GQL_API_ENDPOINT,
  })
)(LearnerHeader);
